import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { Card } from "antd";
import { CasesByTypeOverYearsChart } from "../analytics/case-level/charts";

const CasesPerYear = props => {
  const q = { [`judges.${props.type}`]: props.name };
  const linkToPTABAnalytics = (
    <Link
      to={{
        pathname: "/ptab/analytics/case-level/by-status-and-phase",
        query: q
      }}
    >
      {"See More PTAB Analytics"}
    </Link>
  );
  return (
    <Card title="PTAB Cases Per Year" extra={linkToPTABAnalytics} style={props.style}>
      <CasesByTypeOverYearsChart query={q} height={197} margin={{ left: 30, top: 15, right: 15, bottom: 30 }} />
    </Card>
  );
};
CasesPerYear.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["author", "panel"]).isRequired
};

export default CasesPerYear;
